<ng-container *ngIf="worksheetItem.WorksheetType == worksheetType.Download">
  <!-- pdf -->
  <div class="card border-0 p-0 rounded-4 download-card">
    <div class="card-details-div">
      <img
        [src]="worksheetItem.Image | contentImage : '6' : 'marketplace'"
        [alt]="worksheetItem.Title"
        [useDefault]="true"
        [loyaltyType]="'marketplace'"
        draggable="false"
        class="download-image"
      />
      <div class="card-body d-flex flex-column justify-content-between bg-white">
        <p class="text-start title-text font-size-14">{{ worksheetItem.Title }}</p>
        <div class="btn btn-download rounded-4 mx-auto" (click)="getDownload(worksheetId, worksheetItem.Id)" target="_blank">
          <span class="font-size-14 fw-bold text-start header-title text-white text-capitalize">{{
            'worksheet.download.btn' | translate
          }}</span>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="worksheetItem.WorksheetType == worksheetType.Gallery">
  <!-- image -->
  <div class="card border-0 p-0 gallery position-relative" (click)="openGalleryImage(galleryImage)">
    <div class="cursor-pointer">
      <img
        [src]="worksheetItem.Image | contentImage : '6' : 'marketplace'"
        [alt]="worksheetItem.Title"
        [useDefault]="true"
        [loyaltyType]="'marketplace'"
        draggable="false"
      />
    </div>
    <span class="gallery-description">
      <p class="font-size-14 mb-0">{{ worksheetItem.Title }}</p>
    </span>
  </div>
  <ng-template #galleryImage let-modal>
    <div class="modal-body">
      <button type="button" class="btn-close-modal" (click)="modal.dismiss()">
        <span class="icon material-icons">cancel</span>
      </button>
      <img
        [src]="worksheetItem.Image | contentImage : '6' : 'marketplace'"
        class="modal-image worksheet-gallery-image"
        [alt]="worksheetItem.Title"
        [@zoomAnimation]
      />
    </div>
    <div class="modal-footer">
      <p class="font-size-14 text-white fw-bold">{{ worksheetItem.Title }}</p>
    </div>
  </ng-template>
</ng-container>

<ng-container *ngIf="worksheetItem.WorksheetType == worksheetType.ProviderVideo">
  <!-- video -->
  <div class="card border-0 p-0 player-container rounded-0">
    <div [ngSwitch]="worksheetItem.ProviderId" class="w-100 h-100">
      <ng-container *ngSwitchCase="providerName.Facebook">
        <fgb-facebook-player [streamKey]="worksheetItem.ProviderKey"></fgb-facebook-player>
      </ng-container>
      <ng-container *ngSwitchCase="providerName.YouTube">
        <fgb-youtube-player [streamKey]="worksheetItem.ProviderKey"></fgb-youtube-player>
      </ng-container>
      <ng-container *ngSwitchCase="providerName.StreamingVideoProvider">
        <fgb-svp-player [streamKey]="worksheetItem.ProviderKey"></fgb-svp-player>
      </ng-container>
      <ng-container *ngSwitchCase="providerName.Twitch">
        <fgb-twitch-player [streamKey]="worksheetItem.ProviderKey"></fgb-twitch-player>
      </ng-container>
      <ng-container *ngSwitchCase="providerName.Viemo">
        <fgb-vimeo-player [streamKey]="worksheetItem.ProviderKey"></fgb-vimeo-player>
      </ng-container>
      <ng-container *ngSwitchCase="providerName.Boxcast">
        <fgb-boxcast-player [streamKey]="worksheetItem.ProviderKey"></fgb-boxcast-player>
      </ng-container>
      <ng-container *ngSwitchCase="providerName.Streamable">
        <fgb-streamable-player [streamKey]="worksheetItem.ProviderKey"></fgb-streamable-player>
      </ng-container>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="worksheetItem.WorksheetType == worksheetType.Link">
  <!-- link -->
  <div class="card border-0 p-0">
    <div class="card-details-div">
      <img
        [src]="worksheetItem.Image | contentImage : '6' : 'marketplace'"
        [alt]="worksheetItem.Title"
        [useDefault]="true"
        [loyaltyType]="'marketplace'"
        draggable="false"
      />
    </div>
    <a target="_blank" [href]="worksheetItem.LinkUrl" class="btn btn-primary bg-primary text-description border-0 fw-bold">
      <p class="link-description">
        {{ worksheetItem.Description }}
      </p>
    </a>
  </div>
</ng-container>
